import React from 'react';

import { getFallbackLocale } from '../../../i18n';
import { LabelName, LabelType } from './types';
import { locale } from '../../../config';
import { NoticeLink } from '../AppDetails/common';
import { DeveloperContactButton } from '../ContactDeveloper/index';
import { DeveloperContactLink } from '../ContactDeveloper/ContactLink';

export const LABELS: LabelType[] = [
  {
    shouldDisplay: (app) => app.hasNoVersionAvailable && !app.availableForDevice,
    translationKey: () => 'cannotInstallNotice',
    name: LabelName.CANNOT_INSTALL,
  },
  {
    shouldDisplay: (app) => app.hasNoVersionAvailable && app.availableForDevice,
    translationKey: () => 'cannotInstallNoticeNoVersion',
    labelMessage: ({ message, link }) => {
      const href = `https://help.fitbit.com/articles/en_US/Help_article/1871/?l=${getFallbackLocale(
        locale
      ).replace('-', '_')}`;

      return (
        <div>
          {message}{' '}
          <NoticeLink href={href} newLine>
            {link}
          </NoticeLink>
        </div>
      );
    },
    name: LabelName.CANNOT_INSTALL_NO_VERSION_AVAILABLE,
  },
  {
    shouldDisplay: (app) => {
      if (!app.hasNoVersionAvailable) {
        if (app.isRestrictedForUserRegion()) {
          return true;
        }

        if (app.cannotInstallOnDevice) {
          return true;
        }
      }
      return false;
    },
    translationKey: (app) => {
      if (!app.hasNoVersionAvailable) {
        if (app.isRestrictedForUserRegion()) {
          return 'cannotInstallNoticeNoRegion';
        }

        if (app.cannotInstallOnDevice) {
          return 'cannotInstallNoticeDeviceDisconnected';
        }
      }
      return '';
    },
    name: LabelName.CANNOT_INSTALL_REGION_VERSION,
  },
  {
    shouldDisplay: (app) => app.compatibilityMode,
    translationKey: () => 'compatibility',
    labelMessage: ({ message, link }, app, { phoneAppVersion, deviceName }) => (
      <div>
        {message}
        <DeveloperContactButton
          id='DeveloperContactButton'
          app={app}
          phoneAppVersion={phoneAppVersion}
          label={link as string}
          showLabel={true}
          deviceName={deviceName}
          LinkComponent={DeveloperContactLink}
        />
      </div>
    ),
    name: LabelName.COMPATIBILITY,
  },
  {
    shouldDisplay: (app) => app.isPaid,
    translationKey: () => 'paid',
    name: LabelName.PAID,
  },
];